

// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import axios from "../api/axiosAuth";
// import { useAuth } from "../context/AuthContext";
// import { API as BASE_API } from "../components/config";
// import "../style/HorasSocialesRector.css";

// /* =========================
//    🔥 FIX: evitar doble /api
// ========================= */
// const API_URL = `${BASE_API}/horas-sociales`;

// export default function HorasSocialesProfesor() {
//   const { token, user } = useAuth();

//   const [horasPendientes, setHorasPendientes] = useState([]);
//   const [historial, setHistorial] = useState([]);
//   const [valoresAprobacion, setValoresAprobacion] = useState({});
//   const [loading, setLoading] = useState(false);

//   /* =========================
//      AXIOS CONFIG SEGURA
//   ========================= */
//   const authConfig = useMemo(() => {
//     if (!token) return null;

//     return {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "X-Tenant-ID": user?.institucion_id || user?.tenant_id || "",
//         "X-Sede-ID": user?.sede_id || "",
//       },
//     };
//   }, [token, user]);

//   /* =========================
//      CARGAR DATOS
//   ========================= */
//   const fetchData = useCallback(async () => {
//     if (!authConfig) return;

//     try {
//       setLoading(true);

//       const [pendientesRes, historialRes] = await Promise.all([
//         axios.get(`${API_URL}/profesor/pendientes`, authConfig),
//         axios.get(`${API_URL}/profesor/historial`, authConfig),
//       ]);

//       setHorasPendientes(pendientesRes.data?.horas || []);
//       setHistorial(historialRes.data?.horas || []);
//     } catch (err) {
//       console.error("❌ Error al cargar horas sociales:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [authConfig]);

//   useEffect(() => {
//     if (token) fetchData();
//   }, [token, fetchData]);

//   /* =========================
//      APROBAR
//   ========================= */
//   const handleAprobar = async (id, max) => {
//     const valor = parseFloat(valoresAprobacion[id]);

//     if (!valor || valor <= 0) {
//       return alert("Ingrese un valor válido.");
//     }

//     if (valor > max) {
//       return alert(`No puede aprobar más de ${max} horas.`);
//     }

//     try {
//       await axios.put(
//         `${API_URL}/aprobar/${id}`,
//         { horas_aprobadas: valor },
//         authConfig
//       );

//       setValoresAprobacion((prev) => {
//         const copy = { ...prev };
//         delete copy[id];
//         return copy;
//       });

//       fetchData();
//     } catch (err) {
//       console.error(err);
//       alert("Error al aprobar.");
//     }
//   };

//   /* =========================
//      RECHAZAR
//   ========================= */
//   const handleRechazar = async (id) => {
//     if (!window.confirm("¿Rechazar solicitud?")) return;

//     try {
//       await axios.put(
//         `${API_URL}/rechazar/${id}`,
//         {},
//         authConfig
//       );

//       fetchData();
//     } catch (err) {
//       console.error(err);
//       alert("Error al rechazar.");
//     }
//   };

//   /* =========================
//      UI HELPERS
//   ========================= */
//   const getStatusStyle = (estado) => {
//     const map = {
//       aprobado: { bg: "#dcfce7", color: "#166534", label: "Aprobado" },
//       rechazado: { bg: "#fee2e2", color: "#991b1b", label: "Rechazado" },
//       pendiente: { bg: "#fef9c3", color: "#854d0e", label: "Pendiente" },
//     };

//     return map[estado] || { bg: "#eee", color: "#333", label: estado };
//   };

//   /* =========================
//      UI
//   ========================= */
//   return (
//     <div className="horas-sociales-container fade-in">

//       <header className="header-flex">
//         <h2>📘 Gestión de Horas Sociales</h2>

//         <button onClick={fetchData} disabled={loading}>
//           {loading ? "Cargando..." : "🔄 Actualizar"}
//         </button>
//       </header>

//       {/* ================= PENDIENTES ================= */}
//       <section>
//         <h3>🕓 Pendientes</h3>

//         <table>
//           <thead>
//             <tr>
//               <th>Estudiante</th>
//               <th>Grado</th>
//               <th>Actividad</th>
//               <th>Reportadas</th>
//               <th>Aprobar</th>
//               <th>Acciones</th>
//             </tr>
//           </thead>

//           <tbody>
//             {horasPendientes.length === 0 ? (
//               <tr>
//                 <td colSpan="6">Sin solicitudes</td>
//               </tr>
//             ) : (
//               horasPendientes.map((h) => (
//                 <tr key={h.id}>
//                   <td>{h.estudiante}</td>
//                   <td>{h.grado}°{h.grupo}</td>
//                   <td>{h.actividad}</td>
//                   <td>{h.horas_reportadas}h</td>

//                   <td>
//                     <input
//                       type="number"
//                       value={valoresAprobacion[h.id] || ""}
//                       onChange={(e) =>
//                         setValoresAprobacion({
//                           ...valoresAprobacion,
//                           [h.id]: e.target.value,
//                         })
//                       }
//                     />
//                   </td>

//                   <td>
//                     <button onClick={() => handleAprobar(h.id, h.horas_reportadas)}>
//                       Aprobar
//                     </button>
//                     <button onClick={() => handleRechazar(h.id)}>
//                       Rechazar
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </section>

//       {/* ================= HISTORIAL ================= */}
//       <section>
//         <h3>📊 Historial</h3>

//         <table>
//           <thead>
//             <tr>
//               <th>Estudiante</th>
//               <th>Actividad</th>
//               <th>Reportadas</th>
//               <th>Aprobadas</th>
//               <th>Estado</th>
//             </tr>
//           </thead>

//           <tbody>
//             {historial.length === 0 ? (
//               <tr>
//                 <td colSpan="5">Sin historial</td>
//               </tr>
//             ) : (
//               historial.map((h) => {
//                 const style = getStatusStyle(h.estado);

//                 return (
//                   <tr key={h.id}>
//                     <td>
//                       {h.estudiante}
//                       <br />
//                       <small>{h.grado}°{h.grupo}</small>
//                     </td>

//                     <td>{h.actividad}</td>
//                     <td>{h.horas_reportadas}h</td>
//                     <td>{h.horas_aprobadas || 0}h</td>

//                     <td>
//                       <span
//                         style={{
//                           background: style.bg,
//                           color: style.color,
//                           padding: "4px 10px",
//                           borderRadius: "10px",
//                         }}
//                       >
//                         {style.label}
//                       </span>
//                     </td>
//                   </tr>
//                 );
//               })
//             )}
//           </tbody>
//         </table>
//       </section>
//     </div>
//   );
// }


//

import React, {
  useEffect,
  useState,
  useCallback
} from "react";

import axios from "../api/axiosAuth";
import { useAuth } from "../context/AuthContext";

import "../style/HorasSocialesRector.css";


export default function HorasSocialesProfesor() {


  const {
    token,
    user
  } = useAuth();



  const [horasPendientes, setHorasPendientes] =
    useState([]);

  const [historial, setHistorial] =
    useState([]);


  const [valoresAprobacion, setValoresAprobacion] =
    useState({});


  const [loading, setLoading] =
    useState(false);



  /* =====================================
      CONFIGURACIÓN HEADERS
  ===================================== */


  const config = {

    headers: {

      Authorization:
        `Bearer ${token}`,

      "X-Tenant-ID":
        user?.tenant_id ||
        user?.institucion_id ||
        "",


      "X-Sede-ID":
        user?.sede_id ||
        ""

    }

  };




  /* =====================================
      CARGAR INFORMACIÓN
  ===================================== */


  const cargarDatos = useCallback(
    async () => {


      if(!token) return;


      try {


        setLoading(true);



        const [
          pendientes,
          historialData

        ] = await Promise.all([


          axios.get(
            "/horas-sociales/profesor/pendientes",
            config
          ),



          axios.get(
            "/horas-sociales/profesor/historial",
            config
          )


        ]);



        setHorasPendientes(

          Array.isArray(
            pendientes.data?.horas
          )

          ?

          pendientes.data.horas

          :

          []

        );



        setHistorial(

          Array.isArray(
            historialData.data?.horas
          )

          ?

          historialData.data.horas

          :

          []

        );



      } catch(error){


        console.error(
          "❌ cargar horas profesor:",
          error
        );


      } finally {


        setLoading(false);


      }


    },

    [
      token,
      user?.tenant_id,
      user?.institucion_id,
      user?.sede_id
    ]

  );






  useEffect(()=>{


    cargarDatos();


  },[cargarDatos]);







  /* =====================================
       APROBAR HORAS
  ===================================== */


  const aprobarHoras = async (
    id,
    maxHoras
  )=>{


    const horas =
      Number(
        valoresAprobacion[id]
      );



    if(
      !horas ||
      horas <= 0
    ){

      return alert(
        "Ingrese las horas aprobadas"
      );

    }




    if(
      horas > Number(maxHoras)
    ){

      return alert(
        `No puede aprobar más de ${maxHoras} horas`
      );

    }




    try{


      await axios.put(

        `/horas-sociales/aprobar/${id}`,

        {

          horas_aprobadas:
            horas

        },

        config

      );



      setValoresAprobacion(
        prev=>{

          const nuevo =
            {...prev};

          delete nuevo[id];

          return nuevo;

        }
      );



      await cargarDatos();



    }catch(error){


      console.error(
        "❌ aprobar:",
        error
      );


      alert(

        error.response?.data?.message ||

        "Error aprobando horas"

      );

    }


  };








  /* =====================================
       RECHAZAR
  ===================================== */


  const rechazarHoras = async(id)=>{


    if(
      !window.confirm(
        "¿Desea rechazar estas horas?"
      )
    ){

      return;

    }



    try{


      await axios.put(

        `/horas-sociales/rechazar/${id}`,

        {},

        config

      );



      await cargarDatos();



    }catch(error){


      console.error(
        "❌ rechazar:",
        error
      );


      alert(

        error.response?.data?.message ||

        "Error rechazando horas"

      );

    }


  };








  return (

    <div className="horas-sociales-container fade-in">


      <div className="header-flex">


        <h2>
          📘 Horas Sociales
        </h2>



        <button
          className="btn-primary"
          onClick={cargarDatos}
          disabled={loading}
        >

          {
            loading
            ?
            "Cargando..."
            :
            "🔄 Actualizar"
          }


        </button>


      </div>






      {/* ===============================
             PENDIENTES
      ================================ */}



      <div className="card">


        <h3>
          🕓 Solicitudes pendientes
        </h3>



        <div className="table-container">


          <table className="tabla-pro">


            <thead>

              <tr>

                <th>
                  Estudiante
                </th>

                <th>
                  Grado
                </th>

                <th>
                  Actividad
                </th>

                <th>
                  Reportadas
                </th>

                <th>
                  Aprobar
                </th>

                <th>
                  Acción
                </th>


              </tr>


            </thead>



            <tbody>


            {
              horasPendientes.length === 0

              ?

              (

                <tr>

                  <td
                    colSpan="6"
                    className="empty"
                  >

                    No hay solicitudes pendientes

                  </td>


                </tr>

              )


              :


              horasPendientes.map(h=>(


                <tr key={h.id}>


                  <td>

                    {h.estudiante}

                  </td>



                  <td>

                    {h.grado}

                    -

                    {h.grupo}

                  </td>



                  <td>

                    {h.actividad}

                  </td>



                  <td>

                    {h.horas_reportadas} h

                  </td>



                  <td>


                    <input

                      type="number"

                      min="1"

                      max={h.horas_reportadas}

                      value={
                        valoresAprobacion[h.id] || ""
                      }


                      onChange={
                        e=>

                        setValoresAprobacion({

                          ...valoresAprobacion,

                          [h.id]:
                            e.target.value

                        })

                      }

                    />


                  </td>



                  <td>


                    <button

                      className="btn-success"

                      onClick={()=>
                        aprobarHoras(
                          h.id,
                          h.horas_reportadas
                        )
                      }

                    >

                      Aprobar

                    </button>



                    <button

                      className="btn-danger"

                      onClick={()=>
                        rechazarHoras(h.id)
                      }

                    >

                      Rechazar

                    </button>


                  </td>



                </tr>


              ))

            }



            </tbody>



          </table>



        </div>


      </div>








      {/* ===============================
              HISTORIAL
      ================================ */}



      <div className="card">


        <h3>
          📊 Historial
        </h3>



        <div className="table-container">


          <table className="tabla-pro">


            <thead>

              <tr>

                <th>
                  Estudiante
                </th>

                <th>
                  Actividad
                </th>

                <th>
                  Reportadas
                </th>

                <th>
                  Aprobadas
                </th>

                <th>
                  Estado
                </th>

              </tr>


            </thead>



            <tbody>


            {

            historial.length===0

            ?

            (

              <tr>

                <td
                  colSpan="5"
                  className="empty"
                >

                  Sin historial

                </td>


              </tr>

            )


            :

            historial.map(h=>(


              <tr key={h.id}>


                <td>

                  {h.estudiante}

                  <br/>

                  <small>
                    {h.grado}-{h.grupo}
                  </small>

                </td>



                <td>
                  {h.actividad}
                </td>



                <td>
                  {h.horas_reportadas} h
                </td>



                <td>
                  {h.horas_aprobadas} h
                </td>



                <td>

                  <span
                    className={
                      `estado ${h.estado}`
                    }
                  >

                    {h.estado}

                  </span>


                </td>



              </tr>


            ))

            }


            </tbody>


          </table>


        </div>



      </div>




    </div>


  );

}